import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check.svg",
  "use": "check.svg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"check.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.366 5.366L7.5 13.233l-2.865-2.867a1.25 1.25 0 00-1.768 1.768l2.868 2.868c.974.974 2.561.97 3.533 0l7.867-7.868a1.25 1.25 0 00-1.768-1.768z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol